import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import AOS from "aos";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import AppRoutes from './routes/Routes';
import { useEffect } from 'react';
import { ToastContainer } from "react-toastify";


const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      window.scrollTo(0, 0);
      // Ensures AOS recalculates animations after route changes in SPA
      AOS.refresh();
    }, [pathname]);

    return null;
  };

function App() {
  // Initialize AOS once for the entire app (all routes)
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out",
      once: true,
      offset: 100,
    });
  }, []);
  
  return (
    <>
          <ToastContainer position="top-right"style={{top:'95px'}} />

      <Router>
        <ScrollToTop/>
        <AppRoutes/>
      </Router>
    </>
  );
}
export default App;
